import React from 'react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const affiliations = [{
    name: 'Michigan Council of Professional Investigators',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oqoZ7aEiwPp5ugwwHCKdcf/1-Michigan_Council_of_Professional_Investigators.png'
  }, {
    name: 'National Association of Legal Investigators',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1ZdEy1EQFmmDJErwdVqHuX/2-National_Assication_of_Legal_Investigaors.png'
  }, {
    name: 'The National Council of Investigation & Security Services',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2a9z8mHVAsN768efjEPnMx/3-The_National_Council_of_Investigation__Security_Services.png'
  }, {
    name: 'World Association of Detectives',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8ABxeDC3ppBCEUM6pDZH8j/4-World_Association_of_Detectives.png'
  }, {
    name: 'The Criminal Defense Investigation Training Council',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r9F5cBcWG3nFFDUy8C8qhZ/5-The_Criminal_Defense_Investigation_Training_Council.png'
  }, {
    name: 'Northville Chamber of Commerce',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bMVvzhymwr8hsYbddbY8XL/6-Northville_Chamber_of_Commerce.png'
  }, {
    name: 'National Arab American Bar Association, Michigan Chapter',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vxpfQCNsiVFnGgoBw1RRi5/7-National_Arab_American_Bar_Assocation%2C_Michigan_Chapter.webp'
  }];
  return <footer className="bg-kgi-blue-900 text-mw-gray-300" data-id="element-119">
      <div className="container mx-auto px-4 py-12" data-id="element-120">
        <div className="mb-8 pb-8 border-b border-kgi-blue-700" data-id="element-121">
          <h3 className="font-serif text-white font-bold text-center mb-6 text-xl" data-id="element-122">
            Professional Affiliations
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8" data-id="element-123">
            {affiliations.map((affiliation, index) => <div key={index} className="flex items-center justify-center bg-white rounded p-2" style={{
            width: '140px',
            height: '100px'
          }} data-id="element-124">
                <img src={affiliation.logo} alt={affiliation.name} className="max-w-full max-h-full object-contain" data-id="element-125" />
              </div>)}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-126">
          <div data-id="element-127">
            <div className="flex items-center mb-4" data-id="element-128">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uPFpggHPzcmoKqW3YEzkT4/KGI-logo.png" alt="KGI Logo" className="h-12 w-12 mr-3 bg-white rounded-full p-1" data-id="element-129" />
              <div data-id="element-130">
                <h3 className="font-serif text-white font-bold" data-id="element-131">
                  Koda Group Inc.
                </h3>
                <p className="text-sm text-mw-gray-400" data-id="element-132">
                  Private Investigations & Security
                </p>
              </div>
            </div>
            <p className="text-sm mb-4" data-id="element-133">
              Licensed and insured private investigations and security services
              company serving Michigan, Illinois, Indiana, and Ohio.
            </p>
            <p className="text-sm" data-id="element-134">
              <a href="mailto:info@koda-is.com" className="hover:text-white" data-id="element-135">
                info@koda-is.com
              </a>
              <br data-id="element-136" />
              <a href="tel:3138446179" className="hover:text-white" data-id="element-137">
                313-844-6179
              </a>
            </p>
          </div>
          <div data-id="element-138">
            <h3 className="font-serif text-white font-bold mb-4" data-id="element-139">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-140">
              <li data-id="element-141">
                <a href="#" className="hover:text-white" data-id="element-142">
                  Home
                </a>
              </li>
              <li data-id="element-143">
                <a href="#services" className="hover:text-white" data-id="element-144">
                  Services
                </a>
              </li>
              <li data-id="element-145">
                <a href="#about" className="hover:text-white" data-id="element-146">
                  About
                </a>
              </li>
              <li data-id="element-147">
                <a href="#" className="hover:text-white" data-id="element-148">
                  Case Intake Info
                </a>
              </li>
              <li data-id="element-149">
                <a href="#contact" className="hover:text-white" data-id="element-150">
                  Contact Us
                </a>
              </li>
              <li data-id="element-151">
                <a href="#" className="hover:text-white" data-id="element-152">
                  Client Login
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-153">
            <h3 className="font-serif text-white font-bold mb-4" data-id="element-154">
              Our Services
            </h3>
            <ul className="space-y-2" data-id="element-155">
              <li data-id="element-156">
                <a href="#" className="hover:text-white" data-id="element-157">
                  Criminal
                </a>
              </li>
              <li data-id="element-158">
                <a href="#" className="hover:text-white" data-id="element-159">
                  Corporate
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-white" data-id="element-161">
                  Domestic
                </a>
              </li>
              <li data-id="element-162">
                <a href="#" className="hover:text-white" data-id="element-163">
                  Child Custody
                </a>
              </li>
              <li data-id="element-164">
                <a href="#" className="hover:text-white" data-id="element-165">
                  Missing Persons
                </a>
              </li>
              <li data-id="element-166">
                <a href="#" className="hover:text-white" data-id="element-167">
                  Construction Investigations
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-168">
            <h3 className="font-serif text-white font-bold mb-4" data-id="element-169">
              Service Areas
            </h3>
            <ul className="space-y-2" data-id="element-170">
              <li data-id="element-171">
                <a href="#" className="hover:text-white" data-id="element-172">
                  Michigan
                </a>
              </li>
              <li data-id="element-173">
                <a href="#" className="hover:text-white" data-id="element-174">
                  Illinois
                </a>
              </li>
              <li data-id="element-175">
                <a href="#" className="hover:text-white" data-id="element-176">
                  Indiana
                </a>
              </li>
              <li data-id="element-177">
                <a href="#" className="hover:text-white" data-id="element-178">
                  Ohio
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-kgi-blue-700 mt-12 pt-8 text-sm text-center" data-id="element-179">
          <p data-id="element-180">&copy; {currentYear} Koda Group Inc. All Rights Reserved.</p>
          <p className="mt-2" data-id="element-181">
            <a href="#" className="hover:text-white mx-2" data-id="element-182">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white mx-2" data-id="element-183">
              Terms of Service
            </a>
          </p>
        </div>
      </div>
    </footer>;
};